export default class UsuarioRepresentanteViewModel {
    constructor () {
        this.Id = undefined
        this.NomeRepresentante = undefined
        this.NomeUsuario = undefined
        this.UsuarioId = undefined
        this.RepresentanteId = undefined
        this.Edicao = undefined
        this.AcessoAdministrador= undefined
    }
}